import GrowLogo from "../../../assets/images/Authentication/AppLogo.svg";

const AuthWrapper = ({ children, className = "" }) => {
  // const [user, setUser] = useState(null);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setUser("user" + Math.floor(Math.random() * 10000000000)?.toString());
  //   }, 1000);
  // }, []);

  // useEffect(() => {
  //   if (!!user) {
  //     Userpilot.initialize("NX-1ebaefb1");
  //     Userpilot.identify(user, {});
  //     Userpilot.trigger("Qa_-OJXmiN");
  //   }
  // }, [user]);

  return (
    <>
      {/* <div className="feedback-wrapper">
        <div className="feedback-card">
          <div className="right-bar">
            <div className="text-parent">
              <ReactSVG src={FeedbackIcon} />
              <h6>A New Way to Sign-In</h6>
            </div>
            <p>We’ve improved this page with you in mind.</p>
          </div>
          <div className="left-bar">
            <button
              className="btn btn-link"
              onClick={() => Userpilot.trigger("survey:nS9w-z24qP")}
            >
              Share feedback
            </button>
            <button className="btn btn-primary">Learn more</button>
          </div>
        </div>
      </div> */}
      <div className={`authentication-page ${className}`}>
        <div className="authentication-section">
          <div className="authentication-banner">
            <div className="authentication-form-card">
              <div className="authentication-header-logo">
                <img alt="grow logo" src={GrowLogo} />
              </div>
              <div className="authentication-form-wrapper">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthWrapper;
